var _excluded = ["image", "fallbackIcon", "size", "isDisabled", "isReadOnly", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Image } from '../../media';
import { _BaseIcon } from '../_BaseIcon';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * @private For internal use only.
 */
export var _ImageIcon = forwardRef((_ref, ref) => {
  var {
    image,
    fallbackIcon,
    size = 'medium',
    isDisabled,
    isReadOnly,
    variant
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var styles = useStyleConfig('_ImageIcon', {
    size
  });
  var [isImageError, setIsImageError] = useState(false);

  var onImageError = () => {
    setIsImageError(true);
  };

  var sharedProps = _objectSpread({
    ref,
    'data-component': '_ImageIcon'
  }, otherProps);

  return image && !isImageError ? /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    as: "span",
    __css: styles
  }, sharedProps), {}, {
    "aria-disabled": isDisabled,
    "data-readonly": isReadOnly || undefined,
    children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
      onError: onImageError
    }))
  })) : /*#__PURE__*/_jsx(_BaseIcon, _objectSpread(_objectSpread({}, sharedProps), {}, {
    type: fallbackIcon,
    size: size,
    color: "neutral.black",
    "aria-label": "".concat(fallbackIcon, "-image-icon"),
    isDisabled: isDisabled,
    isReadOnly: isReadOnly
  }));
});
_ImageIcon.displayName = '_ImageIcon';
//# sourceMappingURL=_ImageIcon.js.map